import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, Suspense as _Suspense } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "form__submit btn btn--fullscreen" }

import Loader from "@/components/layout/Loader.vue";
import {useI18n} from "vue3-i18n";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import {useOrganizationService} from "@/inversify.config";
import {onMounted, ref} from "vue";
import Card from "@/components/layout/Card.vue";
import {IOrganization} from "@/types/entities/organization";
import {notifyError, notifySuccess} from "@/notify";
import {FormOption} from "@/types";
import FormSearchableSelect from "@/components/forms/FormSearchableSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminOrganizationMergeForm',
  setup(__props) {

const {t} = useI18n()
const organizationService = useOrganizationService();

const organizationOptions = ref<FormOption[]>();
const sourceOrganizationId = ref<string>();
const destinationOrganizationId = ref<string>();
const organizationIsLoading = ref(false);

onMounted(() => {
  loadOrganizations()
})

async function loadOrganizations() {
  organizationIsLoading.value = true;
  let organizations = await organizationService.getAllOrganizations()
  organizationOptions.value = organizations
    .map((x: IOrganization) => ({
      name: x.id.toString(),
      label: x.name
    }))
    .sortByLabel()
  organizationIsLoading.value = false;
}

async function handleSubmit() {
  if (!sourceOrganizationId.value) {
    notifyError(t('validation.organization.merge.chooseOrganizationToDelete'))
    return;
  }

  if (!destinationOrganizationId.value) {
    notifyError(t('validation.organization.merge.chooseOrganizationToKeep'))
    return;
  }

  if (sourceOrganizationId.value === destinationOrganizationId.value) {
    notifyError(t('validation.organization.merge.organizationToDeleteAndToKeepCannotBeTheSame'))
    return;
  }

  let succeededOrNotResponse = await organizationService
    .mergeTwoOrganizations(sourceOrganizationId.value, destinationOrganizationId.value)
  if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
    notifySuccess(t('validation.organization.merge.success'))
  } else {
    let errorMessages = succeededOrNotResponse.getErrorMessages(
        'validation.organization.merge', 'validation.organization.merge.errorOccurred');
    notifyError(errorMessages[0])
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Breadcrumbs, {
          title: _unref(t)(`routes.admin.children.organizations.merge.name`)
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BackLinkTitle, {
            title: _unref(t)('routes.admin.children.organizations.merge.name')
          }, null, 8, ["title"])
        ]),
        _createVNode(Card, null, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              class: "form",
              onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, [
              (organizationOptions.value)
                ? (_openBlock(), _createBlock(FormSearchableSelect, {
                    key: 0,
                    modelValue: sourceOrganizationId.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sourceOrganizationId).value = $event)),
                    label: _unref(t)('organization.toDelete'),
                    options: organizationOptions.value,
                    name: "sourceOrganization"
                  }, null, 8, ["modelValue", "label", "options"]))
                : _createCommentVNode("", true),
              (organizationOptions.value)
                ? (_openBlock(), _createBlock(FormSearchableSelect, {
                    key: 1,
                    modelValue: destinationOrganizationId.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((destinationOrganizationId).value = $event)),
                    label: _unref(t)('organization.toKeep'),
                    options: organizationOptions.value,
                    name: "destinationOrganization"
                  }, null, 8, ["modelValue", "label", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("button", _hoisted_4, _toDisplayString(_unref(t)('global.merge')), 1)
            ], 40, _hoisted_3)
          ]),
          _: 1
        })
      ])
    ]),
    fallback: _withCtx(() => [
      _createVNode(Loader)
    ]),
    _: 1
  }))
}
}

})